import PixelsGrid from '../components/Grid';
import { PixelProvider } from '../store';

export default function PixelsGridLayout() {
  return <PixelProvider>
    <PixelsGrid />
  </PixelProvider>;
}
